import React, { Component } from 'react';
import QbmModal from '../../../../modals/common/QbmModal';
import { Field, reduxForm } from 'redux-form'
import InputField from '../../../../helpers/Fields/InputField';
import PropTypes from 'prop-types'
import { required, email, numericality } from 'redux-form-validators'

class FormModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  render() {
    const {formatMessage} = this.context;

    const {handleClose, isOpen, handleSubmit, initialValues} = this.props;
    return (
      <QbmModal
        show={isOpen}
        title={initialValues.id ? formatMessage('FormUpdatePlanPayment') : formatMessage('FormNewPlanPayment')}
        onClose={handleClose}
      >
        <form className="create-dialog-form" onSubmit={handleSubmit(this.props.save)}>
          <Field
            name="title"
            label={formatMessage('titlePlan')}
            component={InputField}
            validate={[required()]}
          />
          <Field
            name="months"
            label={formatMessage('monthsPlan')}
            component={InputField}
            validate={[required(), numericality({ int: true , '>': 0})]}
          />
          <Field
            name="amount"
            label={formatMessage('amountPlan')}
            component={InputField}
            validate={[required(), numericality({ '>=': 0})]}
          />
          <div className="actions">
            <button
                className="btn btn-primary"
                type="submit"
            >{formatMessage('btnPlanSave')}</button>
          </div>
        </form>
      </QbmModal>
    );
  }
}

export default reduxForm({
  form: 'plan_form' 
})(FormModal)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Plans/components/FormModal/index.jsx